import IStory from '#/types/stories';
import {
  StoryDetailsActionType,
  TStoryDetailsActions,
} from '../actions/storyDetails';

interface IState {
  story: IStory | undefined;
}

const initialState: IState = {
  story: undefined,
};

const storyDetailsReducer = (
  state = initialState,
  { type, payload }: TStoryDetailsActions
): IState => {
  switch (type) {
    case StoryDetailsActionType.STORY_DETAILS_SET_STORY_DETAILS:
      return { ...state, story: payload };

    default:
      return state;
  }
};

export default storyDetailsReducer;
